import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VESSEL_LAST_STOPPAGE_EVENTS, TVesselLastStoppageEventsSliceState, TVesselInfo } from '../mapTypes';

const initialState: TVesselLastStoppageEventsSliceState = {
    vesselLastStoppageEventsData: null,
    vesselLastStoppageEventsLoading: false,
    vesselLastStoppageEventsError: null,
};

const vesselLastStoppageEventsSlice = createSlice({
    name: VESSEL_LAST_STOPPAGE_EVENTS,
    initialState,
    reducers: {
        emptyVesselLastStoppageEventsAction: (state: TVesselLastStoppageEventsSliceState) => {
            state.vesselLastStoppageEventsData = null;
            state.vesselLastStoppageEventsLoading = false;
            state.vesselLastStoppageEventsError = null;
        },
        getVesselLastStoppageEventsRequestAction: (state: TVesselLastStoppageEventsSliceState, _: PayloadAction<{ imoNumber: number, startDate: string, endDate: string }>) => {
            state.vesselLastStoppageEventsLoading = true;
            state.vesselLastStoppageEventsError = null;
        },
        getVesselLastStoppageEventsSuccessAction: (
            state: TVesselLastStoppageEventsSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselLastStoppageEventsLoading = false;
            state.vesselLastStoppageEventsData = data;
            state.vesselLastStoppageEventsError = null;
        },
        getVesselLastStoppageEventsErrorAction: (
            state: TVesselLastStoppageEventsSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselLastStoppageEventsData = null;
            state.vesselLastStoppageEventsLoading = false;
            state.vesselLastStoppageEventsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const { emptyVesselLastStoppageEventsAction, getVesselLastStoppageEventsRequestAction, getVesselLastStoppageEventsErrorAction, getVesselLastStoppageEventsSuccessAction } =
    vesselLastStoppageEventsSlice.actions;
export default vesselLastStoppageEventsSlice.reducer;
